export const recentHistoryStyles = {
	listGroup: {
		display: 'flex',
		flexDirection: 'column',
		padding: 0,
		listStyleType: 'none'
	},
	listOption: {
		px: 1,
		'&.Mui-focused': {
			backgroundColor: 'primary.hover'
		}
	}
};
